import React from 'react';
import { UserPlusIcon, EyeIcon, RotateCcwIcon, Trash2Icon, CheckCircle2Icon, SearchIcon } from 'lucide-react';
const MOCK_USERS = [{
  id: 1,
  name: 'Adam Shrufer',
  email: 'adam@autoflash.net',
  type: 'Corporatif',
  status: 'actif',
  onboarding: 'sélection_rendez_vous'
}, {
  id: 2,
  name: 'Andréa Legros',
  email: 'andrealegros@gmail.com',
  type: 'Individu',
  status: 'actif',
  onboarding: 'Complet'
}, {
  id: 3,
  name: 'Robert Provencal',
  email: 'robert.provencal.jr@gmail.com',
  type: 'Individu',
  status: 'actif',
  onboarding: 'Complet'
}, {
  id: 4,
  name: 'Audrey Marin',
  email: 'Audreymarin007@gmail.com',
  type: 'Individu',
  status: 'actif',
  onboarding: 'Complet'
}, {
  id: 5,
  name: 'JC Marin',
  email: 'marin.jeancharles@gmail.com',
  type: 'Individu',
  status: 'actif',
  onboarding: 'Complet'
}, {
  id: 6,
  name: 'Hugo Langlais',
  email: 'hugo.langlais@metix.ca',
  type: 'Corporatif',
  status: 'actif',
  onboarding: 'Complet'
}, {
  id: 7,
  name: 'Jean-Charles Marin',
  email: 'jean-charles.marin@cedarstrategies.ca',
  type: 'Corporatif',
  status: 'actif',
  onboarding: 'Complet',
  hasCheck: true
}, {
  id: 8,
  name: 'Nayla Feghali',
  email: 'nayla.feghali@cedarstrategies.ca',
  type: 'Corporatif',
  status: 'actif',
  onboarding: 'sélection_notification_active',
  hasCheck: true
}, {
  id: 9,
  name: 'Vivianne Gravel',
  email: 'vivianne.gravel@metix.ca',
  type: 'Corporatif',
  status: 'actif',
  onboarding: 'sélection_notification_active',
  hasCheck: true
}, {
  id: 10,
  name: 'Salman Salem',
  email: 'salman.salem@metix.ca',
  type: 'Corporatif',
  status: 'actif',
  onboarding: 'Complet'
}, {
  id: 11,
  name: '—',
  email: 'dogan.erisen@metix.ca',
  type: 'Corporatif',
  status: 'actif',
  onboarding: 'sélection_notification_active'
}, {
  id: 12,
  name: '—',
  email: 'dogan.erisen@bciti.com',
  type: 'Corporatif',
  status: 'actif',
  onboarding: 'sélection_notification_active'
}, {
  id: 13,
  name: 'Admin User',
  email: 'admin@borg.local',
  type: 'Individu',
  status: 'actif',
  onboarding: 'consentement'
}];
export function UsersModule() {
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-5819" data-mp="20xrt7cu4pjn2">
      <div className="flex items-start justify-between gap-4 mb-8" data-id="element-5820" data-mp="1w5rluzbqbogg">
        <div data-id="element-5821" data-mp="1r7gc0olfpdy8">
          <h1 className="text-2xl font-bold text-[#0F172A] font-heading mb-1" data-id="element-5822" data-mp="1r7yisf5q3ake">
            Usagers
          </h1>
          <p className="text-slate-500 text-sm font-body" data-id="element-5823" data-mp="1m8lvxueuq3ht">
            Gérez les utilisateurs et leurs accès.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-between mb-6" data-id="element-5824" data-mp="1i8v0veial17h">
        <div className="flex items-center gap-4 flex-1" data-id="element-5825" data-mp="1d8goxldkl746">
          <div className="relative w-full max-w-md" data-id="element-5826" data-mp="188knntw9btsb">
            <SearchIcon className="absolute left-3 top-2.5 w-4 h-4 text-slate-400" data-id="element-5827" data-mp="18a5gnf2xb4o2" />
            <input type="text" placeholder="Rechercher un usager..." className="w-full pl-9 pr-4 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent font-body" data-id="element-5828" data-mp="37kdl1rmyj15k" />
          </div>
          <span className="text-sm text-slate-500 font-body" data-id="element-5829" data-mp="3f57qjexfequl">13 usagers</span>
        </div>

        <button className="flex items-center gap-2 bg-[#0F172A] hover:bg-[#1E293B] text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors font-body shadow-sm" data-id="element-5830" data-mp="3f2v00ddlr85x">
          <UserPlusIcon size={16} data-id="element-5831" data-mp="3ou93ew8ocs4c" />
          Créer un usager
        </button>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" data-id="element-5832" data-mp="2r8tka4c97h4j">
        <table className="w-full text-left text-sm font-body" data-id="element-5833" data-mp="2w74y0q5o6bs1">
          <thead className="bg-slate-50/50 border-b border-slate-200 text-slate-500" data-id="element-5834" data-mp="314ww61wwqu4o">
            <tr data-id="element-5835" data-mp="3649k6pzim78u">
              <th className="px-6 py-4 font-medium" data-id="element-5836" data-mp="364t2w8wzoznx">Nom</th>
              <th className="px-6 py-4 font-medium" data-id="element-5837" data-mp="3626k1d4nexqe">Email</th>
              <th className="px-6 py-4 font-medium" data-id="element-5838" data-mp="gefogltzrope">Type</th>
              <th className="px-6 py-4 font-medium" data-id="element-5839" data-mp="le21ov9tl4y7">Statut</th>
              <th className="px-6 py-4 font-medium" data-id="element-5840" data-mp="lgertvpqelmc">Intégration</th>
              <th className="px-6 py-4 font-medium text-right" data-id="element-5841" data-mp="j0ez28t7xzdy">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-5842" data-mp="ezd6gatt4lky">
            {MOCK_USERS.map(user => <tr key={user.id} className="hover:bg-slate-50/50 transition-colors group" data-id="element-5843" data-mp="syuqye02lcoi">
                <td className="px-6 py-4 text-slate-700 font-medium" data-id="element-5844" data-mp="nygsnno9th3o">
                  {user.name}
                </td>
                <td className="px-6 py-4 text-slate-600" data-id="element-5845" data-mp="11x6pr3b3bgs1">{user.email}</td>
                <td className="px-6 py-4" data-id="element-5846" data-mp="xxpka9vnyjmv">
                  {user.type === 'Corporatif' ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-50 text-[#4F46E5] border border-indigo-100" data-id="element-5847" data-mp="1bob3jzp14vla">
                      Corporatif
                    </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border border-slate-200 text-slate-600 bg-white" data-id="element-5848" data-mp="1lm8rsn6w2sdw">
                      Individu
                    </span>}
                </td>
                <td className="px-6 py-4" data-id="element-5849" data-mp="20a8qscnjzr5l">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#0F172A] text-white" data-id="element-5850" data-mp="207cwqzettmmf">
                    {user.status}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-5851" data-mp="1va49wliqgueu">
                  {user.onboarding === 'Complet' ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#0F172A] text-white" data-id="element-5852" data-mp="1vc799w5rzzw8">
                      {user.onboarding}
                    </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border border-slate-200 text-slate-600 bg-white" data-id="element-5853" data-mp="1ld7zubd6s086">
                      {user.onboarding}
                    </span>}
                </td>
                <td className="px-6 py-4" data-id="element-5854" data-mp="xmm67p3xiihp">
                  <div className="flex items-center justify-end gap-3 text-slate-400" data-id="element-5855" data-mp="xmvvtbl2anmv">
                    <button className="hover:text-[#4F46E5] transition-colors" title="Voir les détails" data-id="element-5856" data-mp="12k432h4o979c">
                      <EyeIcon size={16} data-id="element-5857" data-mp="jhlsfpy1xtqp" />
                    </button>
                    {user.hasCheck && <button className="hover:text-[#4F46E5] transition-colors" title="Vérifier" data-id="element-5858" data-mp="ep2dopnmoskb">
                        <CheckCircle2Icon size={16} data-id="element-5859" data-mp="9s262ab4rhr3" />
                      </button>}
                    <button className="hover:text-[#4F46E5] transition-colors" title="Réinitialiser" data-id="element-5860" data-mp="4spbt4hxj8eh">
                      <RotateCcwIcon size={16} data-id="element-5861" data-mp="12fy3xicfrfpg" />
                    </button>
                    <button className="hover:text-red-500 transition-colors" title="Supprimer" data-id="element-5862" data-mp="xguy3vomt5gf">
                      <Trash2Icon size={16} data-id="element-5863" data-mp="sh8ijflbzd4g" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}